import { IconButton, Stack, Tooltip } from "@mui/material";
import { sendDataToIframe } from "../Utilities";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

export default function ManagerControls({ children, invertColors }) {

    const { t } = useTranslation()

    return (
        <Stack direction="row" sx={{ flexGrow: 1, minWidth: 0 }}>
            <Tooltip 
                title={t("actions.home")}
                arrow
            >
                <IconButton
                    sx={{ padding: "0 0 1px 0", color: invertColors ? 'white' : 'primary.main' }}
                    onClick={() => sendDataToIframe({ type: "goHome" })}
                >
                    <ArrowBackIos sx={{ fontSize: "1.2rem", mr: -0.75 }} />
                    <ArrowBackIos sx={{ fontSize: "1.2rem", ml: -0.75 }} />
                </IconButton>
            </Tooltip>
            <Tooltip 
                title={t("actions.previous")}
                arrow
            >
                <IconButton
                    sx={{ padding: "0 0 1px 4px", color: invertColors ? 'white' : 'primary.main' }}
                    onClick={() => sendDataToIframe({ type: "goPrevious" })}
                >
                    <ArrowBackIos sx={{ fontSize: "1.2rem" }} />
                </IconButton>
            </Tooltip>
                {children}
            <Tooltip
                title={t("actions.next")}
                arrow
            >
                <IconButton
                    sx={{ padding: "0 8px 1px 6px", color: invertColors ? 'white' : 'primary.main' }}
                    onClick={() => sendDataToIframe({ type: "goNext" })}
                >
                    <ArrowForwardIos sx={{ fontSize: "1.2rem" }} />
                </IconButton>
            </Tooltip>
        </Stack>
    )
}